export type LegalDocument = {
  audience: string;
  version: string;
  content: string;
  sha256: string;
};
export type BusinessOrder = {
  organization: string;
  locations: { id: string; name: string }[];
  currency: string;
  main_plan: {
    price_cents: number;
    billing_start: string;
    minimum_term: string;
    minimum_term_start: string;
    renewal: string;
  };
  integrations: {
    provider: 'opentable' | 'resy';
    location_id: string;
    price_cents: number;
    basis: string;
    billing_start: string;
    continues_after_launch?: boolean;
  }[];
  checkout_mode: 'setup' | 'payment' | 'subscription';
  due_now_cents: number;
  tax_disclosure: string;
  cancellation_instructions: string;
  discounts_and_waivers: string;
  usage_schedule: string;
  negotiated_terms: string;
  agreement: LegalDocument;
  privacy_notice: {
    version: string;
    content: string;
    sha256: string;
    url: string;
  };
  acknowledgments: { business: string; opentable: string | null };
};
export type AcceptanceInput = {
  quote_token: string;
  signer: { name: string; email: string; role: string };
  business_agreed: boolean;
  opentable_agreed: boolean;
};
export const formatLegalMoney = (cents: number, currency: string) =>
  `${currency} ${(cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
